import { useState, type FC, type ReactNode } from 'react'
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '../components/form'
import { Input } from '../components/input'
import { Button } from '../components/button'

import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import { z } from "zod"
import { LoaderCircle } from 'lucide-react'
import ErrorComponent from './ErrorComponent'
import OTPTimer from './OTPTImer'

const otpFormSchema = z.object({
    otp: z.string().min(6, {
        message: "OTP must be exactly 6 digits",
    }).max(6, {
        message: "OTP must be exactly 6 digits",
    }).regex(/^\d+$/, {
        message: "OTP must contain only numbers",
    }),
})

type OtpVerifyFormType = {
    children?: ReactNode,
    onSubmit: (values: z.infer<typeof otpFormSchema>) => void
    handleSendOtp: () => void,
    isError?: boolean,
    isLoading?: boolean,
    isSendOTPError?: boolean,
    isSendOTPPending?: boolean
    timeExpired?: boolean
    setTimeExpired?: React.Dispatch<React.SetStateAction<boolean>>
    verification_id: string
    error?: Error | null,
}

const OtpForm: FC<OtpVerifyFormType> = ({ onSubmit, handleSendOtp, isError, isLoading, isSendOTPError, isSendOTPPending, verification_id, timeExpired, setTimeExpired, error }) => {
    const form = useForm<z.infer<typeof otpFormSchema>>({
        resolver: zodResolver(otpFormSchema),
        defaultValues: {
            otp: "",
        },
    })

    // Extract the error message from various possible error shapes
    const getErrorMessage = (): string => {
      if (!error) return ''

      // AxiosError with response data
      const axiosData = (error as any)?.response?.data
      if (axiosData?.error) {
        return axiosData.error
      }

      // Plain Error object
      if (error?.message) {
        return error.message
      }

      return 'Network error. Please check your connection and try again.'
    }

    return (
        <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8">
                <FormField
                    control={form.control}
                    name="otp"
                    render={({ field }) => (
                        <FormItem className='mb-0'>
                            <FormLabel className='text-[#38404D]'>Enter OTP<span className='text-[#16111]'>*</span></FormLabel>
                            <FormControl className='mt-[6px]'>
                                <Input placeholder="123456" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />
                {

                }
                <p className="text-body2 text-highlight mt-[16px] mb-0">
                    OTP sent to {verification_id}
                </p>
                <p className="text-body2 text-highlight mt-[10px]">
                    {
                        // Hide timer during verification to avoid confusion
                        isLoading ? null :
                        timeExpired ? <div className='flex items-center gap-1'>Did not receive OTP?{" "}
                            <span className="text-[#16111] font-[700] cursor-pointer underline" onClick={() => {
                                handleSendOtp()
                                form.reset()
                            }}>
                                {
                                    isSendOTPPending ? <LoaderCircle className="animate-spin size-4" /> : 'Send again'
                                }

                            </span></div> :
                            <OTPTimer setTimeExpired={setTimeExpired} />
                    }


                </p>
                {
                    (isError || isSendOTPError) && <ErrorComponent message={getErrorMessage()} />
                }
                <Button type="submit" className='w-full mt-[32px]' disabled={isLoading} isLoading={isLoading}>
    {'Submit'}
</Button>
            </form>
        </Form>
    )

}

export { OtpForm, otpFormSchema }